export const trackEvent = (event, data) => {
  if (!window.analytics) {
    return;
  }

  window.analytics.track(event, data);
};
